import { render, staticRenderFns } from "./direcciones.vue?vue&type=template&id=0671c759&scoped=true&"
import script from "./direcciones.vue?vue&type=script&lang=js&"
export * from "./direcciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671c759",
  null
  
)

export default component.exports